import * as React from 'react';
import { DropDownArrow } from '../images/images';
import { colors } from '../styles/colors';
import { largeShadow } from '../styles/styleObjects';

export interface IProps<T> {
    options: Array<T>;
    value: T;
    onChange(value: T): void;
    containerStyle?: React.CSSProperties,
    style?: React.CSSProperties;
}

interface IState {
    showDropDown: boolean;
}

export class SortDropdown<T extends string> extends React.Component<IProps<T>, IState> {
    public state: IState = {
        showDropDown: false
    };

    public render() {
        const { options, value, onChange } = this.props;

        return (
            <React.Fragment>
                <div style={{...relative, ...this.props.containerStyle}}>
                    <div onClick={() => this.setState({ showDropDown: !this.state.showDropDown })} style={{ ...dropdownStyle, ...this.props.style }}>
                        <p style={itemText}>{value}</p>
                        <img src={DropDownArrow} style={dropDownArrow} />
                    </div>
                    {this.state.showDropDown && (
                        <div style={dropdownVisibleContainer}>
                            {options.map(opt => {
                                return (
                                    <p
                                        style={optionRow}
                                        key={opt}
                                        onClick={() => {
                                            onChange(opt);
                                            this.setState({ showDropDown: false });
                                        }}
                                    >
                                        <a style={fullWidth}>{opt}</a>
                                    </p>
                                );
                            })}
                        </div>
                    )}
                </div>
                {this.state.showDropDown && <div style={dropdownBackground} onClick={() => this.setState({ showDropDown: false })} />}
            </React.Fragment>
        );
    }
}

const dropdownBackground: React.CSSProperties = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 999
};

const fullWidth = { width: '100%' };
const relative: React.CSSProperties = { position: 'relative' };

const dropdownVisibleContainer: React.CSSProperties = {
    position: 'absolute',
    top: 55,
    right: 0,
    width: 205,
    backgroundColor: '#302F2E',
    zIndex: 1000,
    boxShadow: largeShadow,
    borderRadius: 4,
    paddingTop: 10,
    paddingBottom: 10
};

const dropDownArrow: React.CSSProperties = {
    height: 15,
    width: 15,
    objectFit: 'contain'
};

const itemText = {
    marginTop: 0,
    fontSize: 15
};

const dropdownStyle: React.CSSProperties = {
    display: 'flex',
    width: 205,
    height: 35,
    backgroundColor: colors.LIGHT_GREY,
    marginTop: 15,
    justifyContent: 'space-between',
    padding: 10,
    borderRadius: 5,
    cursor: 'pointer'
};

const optionRow: React.CSSProperties = {
    height: 35,
    display: 'flex',
    alignItems: 'center',
    fontSize: 18,
    paddingLeft: 30,
    color: 'white',
    cursor: 'pointer'
};



// WEBPACK FOOTER //
// ./src/SharedComponents/SortDropdown.tsx